import { RootPaths } from "../App/paths";

export const NEWS_FEED_PATH = "news-feed";
export const NEWS_FEED_FULL_PATH = `${RootPaths.APP_V2_HOME}/${NEWS_FEED_PATH}`;
